module.exports = __webpack_public_path__ + "img/bg-thanks.daa0af23.jpg";